import React, { useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LatencyButton, LatencyButtonProps } from './LatencyButton';
import { DisplayType, LatencyDisplayType } from './LatencyDisplayType';
import { LatencyTable, LatencyTableProps } from './LatencyTable';

const theme = createTheme({
    components: {
        MuiButton: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiFilledInput: {
            defaultProps: {
                margin: 'dense',
            },
            styleOverrides: {
                sizeSmall: {
                    marginLeft: 4,
                    marginRight: 4,
                    padding: 12,
                },
            },
        },
        MuiFormControl: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFormHelperText: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiIconButton: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiInputBase: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiInputLabel: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiListItem: {
            defaultProps: {
                dense: true,
            },
        },
        MuiOutlinedInput: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFab: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTable: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTextField: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiToolbar: {
            defaultProps: {
                variant: 'dense',
            },
        },
    },
});

export type LatencyPanelProps = LatencyButtonProps & Omit<LatencyTableProps, 'displayType'>;

export function LatencyPanel(props: LatencyPanelProps) {
    const { points, addPoint, clearPoints } = props;
    const [displayType, setDisplayType] = useState<DisplayType>('total');

    return (
        <ThemeProvider theme={theme}>
            <div>
                <LatencyButton points={points} addPoint={addPoint} clearPoints={clearPoints} />
                <LatencyDisplayType displayType={displayType} onChange={setDisplayType} />
                <LatencyTable {...props} displayType={displayType} />
            </div>
        </ThemeProvider>
    );
}
